import * as i0 from '@angular/core';
import * as i1 from './form-field.module';
import * as i2 from '@angular/common';
import * as i3 from '@ng-bootstrap/ng-bootstrap';
import * as i4 from '../tooltip/tooltip.component';
import * as i5 from '../icon/icon.component';
import * as i6 from './error';
import * as i7 from './form-hint';
import * as i8 from './form-field.component';
import * as i9 from '../tooltip/tooltip.module';
import * as i10 from '../icon/icon.module';
export const BllFormFieldModuleNgFactory:i0.NgModuleFactory<i1.BllFormFieldModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any,any> = (<any>(null as any));
var _decl0_3:i2.NgIf<any> = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.NgbTooltip = (<any>(null as any));
var _decl0_12:i4.BllTooltipComponent = (<any>(null as any));
var _decl0_13:i5.BllIconComponent = (<any>(null as any));
var _decl0_14:i6.BllError = (<any>(null as any));
var _decl0_15:i7.BllFormHint = (<any>(null as any));
var _decl0_16:i8.BllFormField = (<any>(null as any));
var _decl0_17:i2.AsyncPipe = (<any>(null as any));
var _decl0_18:i2.UpperCasePipe = (<any>(null as any));
var _decl0_19:i2.LowerCasePipe = (<any>(null as any));
var _decl0_20:i2.JsonPipe = (<any>(null as any));
var _decl0_21:i2.SlicePipe = (<any>(null as any));
var _decl0_22:i2.DecimalPipe = (<any>(null as any));
var _decl0_23:i2.PercentPipe = (<any>(null as any));
var _decl0_24:i2.TitleCasePipe = (<any>(null as any));
var _decl0_25:i2.CurrencyPipe = (<any>(null as any));
var _decl0_26:i2.DatePipe = (<any>(null as any));
var _decl0_27:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_28:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_29:i2.KeyValuePipe = (<any>(null as any));
var _decl0_30:i2.CommonModule = (<any>(null as any));
var _decl0_31:i3.NgbTooltipModule = (<any>(null as any));
var _decl0_32:i9.BllTooltipModule = (<any>(null as any));
var _decl0_33:i10.BllIconModule = (<any>(null as any));
var _decl0_34:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_35:i0.ElementRef<any> = (<any>(null as any));
function _View_BllFormField_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_16._checkError();
  currVal_0;
  const currVal_1:any = _decl0_16.inline;
  currVal_1;
  const currVal_2:any = _decl0_16.width;
  currVal_2;
  const currVal_3:any = _decl0_16.width;
  currVal_3;
  const currVal_4:any = _decl0_16.hidePlaceholder;
  currVal_4;
  const currVal_5:any = _decl0_16._control.disabled;
  currVal_5;
  const currVal_6:any = _decl0_16._control.focused;
  currVal_6;
  const currVal_7:any = _decl0_16._control.shouldLabelFloat;
  currVal_7;
  const currVal_8:any = _decl0_16._shouldForward('untouched');
  currVal_8;
  const currVal_9:any = _decl0_16._shouldForward('touched');
  currVal_9;
  const currVal_10:any = _decl0_16._shouldForward('pristine');
  currVal_10;
  const currVal_11:any = _decl0_16._shouldForward('dirty');
  currVal_11;
  const currVal_12:any = _decl0_16._shouldForward('valid');
  currVal_12;
  const currVal_13:any = _decl0_16._shouldForward('invalid');
  currVal_13;
  const currVal_14:any = _decl0_16._shouldForward('pending');
  currVal_14;
}
function _View_BllFormField_1_1():void {
  if (_decl0_16.prefix) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_16.prefix;
    currVal_0;
  }
}
function _View_BllFormField_1_2():void {
  if (_decl0_16.hint) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_16.hint;
    currVal_0;
    const currVal_1:any = _decl0_12.id;
    currVal_1;
    const currVal_2:any = (-1);
    currVal_2;
  }
}
function _View_BllFormField_1_3():void {
  if (_decl0_16.clearable) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_16.value;
    currVal_0;
    const currVal_1:any = 'x';
    currVal_1;
    const currVal_2:any = _decl0_13.currentClassNames;
    currVal_2;
    const pd_3:any = ((<any>_decl0_16.clear()) !== false);
  }
}
function _View_BllFormField_1_4():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_16._control.placeholder;
  currVal_0;
}
function _View_BllFormField_1_5():void {
  var _any:any = (null as any);
}
function _View_BllFormField_1_6():void {
  if (((!_decl0_16.hideRequiredMarker && _decl0_16._control.required) && !_decl0_16._control.disabled)) { var _any:any = (null as any); }
}
function _View_BllFormField_1_7():void {
  if (_decl0_16._displayError()) { var _any:any = (null as any); }
}
function _View_BllFormField_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_16.prefix;
  currVal_0;
  const currVal_1:any = _decl0_16.hint;
  currVal_1;
  const currVal_2:any = _decl0_16.currency;
  currVal_2;
  const currVal_3:any = _decl0_16.clearable;
  currVal_3;
  const currVal_4:any = _decl0_16._hasLabel();
  currVal_4;
  const currVal_5:any = _decl0_16._labelId;
  currVal_5;
  const currVal_6:any = _decl0_16._control.id;
  currVal_6;
  const currVal_7:any = _decl0_16._control.empty;
  currVal_7;
  const currVal_8:any = false;
  currVal_8;
  const currVal_9:any = true;
  currVal_9;
  const currVal_10:any = ((!_decl0_16.hideRequiredMarker && _decl0_16._control.required) && !_decl0_16._control.disabled);
  currVal_10;
  const currVal_11:any = _decl0_16._displayError();
  currVal_11;
}
